/**************************************************
 * Nombre:       Formulario_Potencial.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    FlagOutlined,
    Mail,
    SchoolOutlined,
    SmartphoneOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPEDIDOS} from "../../Constantes";
import IngresoTextoLista from "../../Modulo_formularios/Componentes/IngresoTextoLista";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {iniciarChatWass} from "../../Modulo_ChatWass/Funciones/iniciarChatWass";

const Formulario_Potencial = ({...props}) => {

    const chatWhatsApp = (num) => {

        iniciarChatWass({numero: props.props.getValues("celular"), pais: props.props.getValues("pais"), local: false});

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSPEDIDOS.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Notificaciones'} {...props}
                                                 dato={'notificaciones'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos Potencial</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTextoBoton Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                       click={chatWhatsApp} IconoFinal={WhatsApp}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Nombre Espacio'} dato={'espacio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SchoolOutlined} nombre={'Profesional'} dato={'profesional'} {...props} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Notas Internas</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={6} nombre={'Notas Internas'} dato={'notas'} {...props} />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Potencial